<template>
  <div>
    <div>
      <el-tabs v-model="activeName" @tab-click="handleClicktab">
        <el-tab-pane label="入库记录" name="first" :lazy="true">
          <div v-if="activeName == 'first'">
            <el-radio-group v-model="radio" size="small" @change="handleClickradio" style="background: #fff;width: 100%;">
              <el-radio-button label="1">卷板</el-radio-button>
              <el-radio-button label="2">建材</el-radio-button>
            </el-radio-group>
            <div v-show="radio == 1">
              <div class="formBox margbot" ref="searchBoxJB">
                <el-form :inline="true" :model="formDataJB" label-width="95px" size="mini" style="width: 100%;">
                  <div class="formItemBox">
                  <el-form-item label="仓库名称:">
                    <el-select size="mini" filterable clearable placeholder="请选择仓库名称" v-model="CKName" multiple
                      >
                      <el-option v-for="(item, index) in CKData" :key="index" :label="item.relTenantName"
                        :value="item.relTenantCode">
                      </el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="捆包编号:">
                    <el-input  v-model="gangJuanNum"
                      size="mini" placeholder="可支持多个" type="textarea"></el-input>
                  </el-form-item>
                  <el-form-item label="入库单编号:">
                    <el-input class="ipt" v-model="formDataJB.instockNo" placeholder="请输入入库单编号" size="mini"
                     ></el-input>
                  </el-form-item>
                  <el-form-item label="入库车牌号:">
                    <el-input class="ipt" v-model="formDataJB.instockPlateNumber" placeholder="请输入入库车牌号" size="mini"
                     ></el-input>
                  </el-form-item>
                  <el-form-item label="规格:">
                    <el-input v-model="formDataJB.specification" size="mini" placeholder="请输入规格"
                     ></el-input>
                  </el-form-item>
                  <el-form-item label="客户名称:">
                    <el-input  class="ipt" v-model="formDataJB.customerName" placeholder="请输入客户名称"
                      size="mini"></el-input>
                  </el-form-item>
                  <el-form-item label="入库客户:">
                    <el-input  class="ipt" v-model="formDataJB.inCustomerName" maxlength="20"
                      placeholder="请输入入库客户" size="mini"></el-input>
                  </el-form-item>
                  <el-form-item label="合约编号:">
                    <el-input class="ipt"  v-model="formDataJB.agreementNumber" placeholder="请输入合约号"
                      size="mini"></el-input>
                  </el-form-item>
                  <el-form-item label="货物类型:">
                    <el-select size="mini" v-model="formDataJB.productType" placeholder="请选择货物类型" style="width:150px"
                      filterable clearable>
                      <el-option v-for="item in typeData" :label="item.show_name" :key="item.show_name"
                        :value="item.item_no"></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="入库日期:" >
                    <div style="display: flex;">
                      <el-date-picker v-model="formDataJB.createTimeStart" size="mini" type="datetime" placeholder="请选择入库日期"
                      value-format="yyyy-MM-dd HH:mm:ss" ></el-date-picker>
                    -
                    <el-date-picker v-model="formDataJB.createTimeEnd" size="mini" placeholder="请选择入库日期" type="datetime"
                      value-format="yyyy-MM-dd HH:mm:ss" ></el-date-picker>
                    </div>

                  </el-form-item>
                  <el-form-item label="合同编号:">
                    <el-input  class="ipt" v-model="formDataJB.contractNumber" placeholder="请输入合同号"
                      size="mini"></el-input>
                  </el-form-item>
                  </div>
                  <el-form-item>
                    <el-button type="primary" size="mini" @click="chaxunJB" btnCode="00ZP00CB001"
                      v-if="btnFlg[0]">查询</el-button>
                    <el-button type="primary" size="mini" @click="chongzhiJB" btnCode="00ZP00C002"
                      v-if="btnFlg[1]">重置</el-button>
                    <el-button type="primary" size="mini" @click="daochuJB" btnCode="00ZP00CB003"
                      v-if="btnFlg[2]">导出</el-button>
                    <el-button type="primary" size="mini" @click="MBdaochuJB" btnCode="00ZP00CB00W"
                      v-if="btnFlg[30]">模板导出</el-button>
                    <span style="margin-left:10px">总吨数：<span style="color:red">{{
                      Number(allWeightJB)
                    }}</span>
                      吨</span>
                    <span style="margin-left:10px">总件数：<span style="color:red">{{ allNumberJB }}</span>
                      件</span>
                  </el-form-item>
                </el-form>
              </div>
              <div :style="{ height: h }">
                <el-table border center bordersize="mini" :data="tableDataJB" height="100%" style="width:100%" size="mini"
                  highlight-current-row :header-cell-style="{ background: '#F5F5F5', color: 'black' }"  class="tableComent">
                  <el-table-column type="index" align="center" label="序号" width="60"></el-table-column>
                  <el-table-column :show-overflow-tooltip="true" prop="organizationName" label="仓库名称"
                    width="250"></el-table-column>
                  <el-table-column :show-overflow-tooltip="true" prop="cargoBarcode" label="捆包号" align="center"
                    width="200"></el-table-column>
                  <el-table-column :show-overflow-tooltip="true" prop="productTypeName" label="货物类型" align="center"
                    width="150"></el-table-column>
                  <el-table-column :show-overflow-tooltip="true" prop="steelMillName" label="产地" align="center"
                    width="150"></el-table-column>
                  <el-table-column :show-overflow-tooltip="true" prop="inCustomerName" label="入库客户" align="center"
                    width="230"></el-table-column>
                  <el-table-column :show-overflow-tooltip="true" prop="customerName" label="客户名称" align="center"
                    width="230"></el-table-column>

                  <el-table-column :show-overflow-tooltip="true" prop="productName" label="品名" align="center"
                    width="150"></el-table-column>
                  <el-table-column :show-overflow-tooltip="true" prop="model" label="材质" width="100"
                    align="center"></el-table-column>
                  <el-table-column :show-overflow-tooltip="true" prop="specification" label="规格" align="center"
                    width="150"></el-table-column>
                  <el-table-column :show-overflow-tooltip="true" prop="weight" label="重量(吨)" align="center"
                    width="150"></el-table-column>
                  <el-table-column :show-overflow-tooltip="true" prop="vehicleNumber" label="车船号" align="center"
                    width="150"></el-table-column>
                  <el-table-column :show-overflow-tooltip="true" prop="contractNumber" label="合同号" align="center"
                    width="150"></el-table-column>
                  <el-table-column :show-overflow-tooltip="true" prop="agreementNumber" label="合约号" align="center"
                    width="150"></el-table-column>
                  <el-table-column :show-overflow-tooltip="true" prop="warehouseName" label="仓库名"
                    align="center"></el-table-column>
                  <el-table-column :show-overflow-tooltip="true" prop="locationName" label="区位名"
                    align="center"></el-table-column>
                  <el-table-column :show-overflow-tooltip="true" prop="binName" label="货位名"
                    align="center"></el-table-column>
                  <el-table-column :show-overflow-tooltip="true" prop="instockNo" label="入库单编号" align="center"
                    width="250"></el-table-column>
                  <el-table-column :show-overflow-tooltip="true" prop="createTime" label="入库日期" align="center"
                    width="180"></el-table-column>
                  <el-table-column :show-overflow-tooltip="true" prop="instockPlateNumber" label="入库车牌号" align="center"
                    width="150"></el-table-column>
                  <el-table-column :show-overflow-tooltip="true" prop="inDriverName" label="入库司机姓名" align="center"
                    width="150"></el-table-column>
                  <el-table-column :show-overflow-tooltip="true" prop="inCreateUser" label="入库单创建人" align="center"
                    width="110"></el-table-column>
                  <el-table-column :show-overflow-tooltip="true" prop="instockUser" label="入库操作人" align="center"
                    width="120"></el-table-column>
                  <el-table-column :show-overflow-tooltip="true" prop="ext1" label="到货方式" align="center"
                    width="150"></el-table-column>
                </el-table>
              </div>
              <div class="pags">
                <el-pagination background @current-change="handleCurrentChangeJB" :current-page="pageInfoJB.pageNo"
                  :page-size="pageInfoJB.pageSize" :page-sizes="[10, 20, 30, 40, 50]"
                  layout="total, sizes, prev, pager, next, jumper" @size-change="handleSizeChangeJB"
                  :total="totalJB"></el-pagination>
              </div>
            </div>
            <!-- 建材 -->
            <div v-show="radio == 2">
              <div class="formBox margbot" ref="searchBoxJC">
                <el-form :inline="true" :model="formDataJC" label-width="95px" size="mini" style="width: 100%;">
                  <div class="formItemBox">
                  <el-form-item label="仓库名称:">
                    <el-select size="mini" filterable clearable placeholder="请选择仓库名称" v-model="CKName" multiple
                      @change="clickCK()" >
                      <el-option v-for="(item, index) in CKData" :key="index" :label="item.relTenantName"
                        :value="item.relTenantCode">
                      </el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="入库单号:">
                    <el-input class="ipt" v-model="formDataJC.instockNo" placeholder="请输入入库单号" size="mini"
                     ></el-input>
                  </el-form-item>
                  <el-form-item label="车辆号牌:">
                    <el-input class="ipt" v-model="formDataJC.instockPlateNumber" placeholder="请输入车号" size="mini"
                     ></el-input>
                  </el-form-item>
                  <el-form-item label="一级货主:">
                    <el-input size="mini" placeholder="请输入一级货主" v-model="formDataJC.primaryCustomerName"
                      ></el-input>
                  </el-form-item>
                  <el-form-item label="二级货主:">
                    <el-input size="mini" placeholder="请输入二级货主" v-model="formDataJC.customerName"
                      ></el-input>
                  </el-form-item>
                  <el-form-item label="货物类型:">
                    <el-select v-model="formData.productType" clearable placeholder="请选择货物类型" filterable size="mini"
                     >
                      <el-option v-for="(item, index) in productTypeData" :key="index" :label="item.productTypeName"
                        :value="item.productType">
                      </el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="产地:">
                    <el-select v-model="formData.steelMillName" clearable placeholder="请选择产地" filterable size="mini"
                      style="width:150px">
                      <el-option v-for="(item, index) in steelMillNameData" :key="index" :label="item" :value="item">
                      </el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="规格:">
                    <el-select v-model="formData.specification" clearable placeholder="请选择规格" filterable size="mini"
                      style="width:150px">
                      <el-option v-for="(item, index) in specificationData" :key="index" :label="item" :value="item">
                      </el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="材质:">
                    <el-select v-model="formData.model" clearable placeholder="请选择材质" filterable size="mini"
                      style="width:150px">
                      <el-option v-for="(item, index) in modelData" :key="index" :label="item" :value="item">
                      </el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="入库日期:">
                    <div style="display: flex;">
                    <el-date-picker v-model="formDataJC.instockDateStart" size="mini" type="datetime"
                      placeholder="请选择入库日期" value-format="yyyy-MM-dd HH:mm:ss" style="width: 175px"></el-date-picker>
                    -
                    <el-date-picker v-model="formDataJC.instockDateEnd" size="mini" placeholder="请选择入库日期" type="datetime"
                      value-format="yyyy-MM-dd HH:mm:ss" style="width: 175px"></el-date-picker>
                     </div>
                  </el-form-item>
                  <el-form-item label="到货方式:">
                    <el-select v-model="formDataJC.arrivalMethod" clearable placeholder="请选择到货方式" filterable size="mini"
                     >
                      <el-option v-for="(item, index) in arrivalMethodData" :key="index" :label="item.label"
                        :value="item.label">
                      </el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="车船编号：">
                    <el-input class="ipt" v-model="formDataJC.plateNumber" placeholder="请输入车船号" size="mini"
                     ></el-input>
                  </el-form-item>
                  </div>
                  <el-form-item>
                    <el-button type="primary" size="mini" @click="chaxunJC" btnCode="00ZP00CB004"
                      v-if="btnFlg[3]">查询</el-button>
                    <el-button type="primary" size="mini" @click="chongzhiJC" btnCode="00ZP00CB005"
                      v-if="btnFlg[4]">重置</el-button>
                    <el-button type="primary" size="mini" @click="daochuJC" btnCode="00ZP00CB006"
                      v-if="btnFlg[5]">导出</el-button>
                    <el-button type="primary" size="mini" @click="MBdaochuJC" btnCode="00ZP00CB00X"
                      v-if="btnFlg[31]">模板导出</el-button>
                    <span style="margin-left:10px">总吨数：<span style="color:red">{{
                      Number(allWeightJC)
                    }}</span>
                      吨</span>
                    <span style="margin-left:10px">总件数：<span style="color:red">{{ allNumberJC }}</span>
                      件</span>
                  </el-form-item>
                </el-form>
              </div>
              <div :style="{ height: H }">
                <el-table border center bordersize="mini" :data="tableDataJC" height="100%" style="width:100%" size="mini"
                  highlight-current-row :header-cell-style="{ background: '#F5F5F5', color: 'black' }" class="tableComent"
                  @row-click="handleRowClick">
                  <el-table-column type="index" align="center" label="序号" width="50"></el-table-column>
                  <el-table-column :show-overflow-tooltip="true" prop="organizationName" label="仓库名称"
                    width="250"></el-table-column>
                  <el-table-column :show-overflow-tooltip="true" prop="instockDate" label="入库时间"
                    width="180"></el-table-column>
                  <el-table-column :show-overflow-tooltip="true" prop="instockUser" label="入库人"
                    width="100"></el-table-column>
                  <el-table-column :show-overflow-tooltip="true" prop="arrivalMethod" label="到货方式" align="center"
                    width="180"></el-table-column>
                  <el-table-column :show-overflow-tooltip="true" prop="instockPlateNumber" label="车号"
                    width="150"></el-table-column>
                  <el-table-column :show-overflow-tooltip="true" prop="primaryCustomerName" label="一级货主"
                    width="220"></el-table-column>
                  <el-table-column :show-overflow-tooltip="true" prop="customerName" label="二级货主"
                    width="220"></el-table-column>
                  <el-table-column :show-overflow-tooltip="true" prop="productTypeName" label="货物类型"
                    width="120"></el-table-column>
                  <el-table-column :show-overflow-tooltip="true" prop="steelMillName" label="产地"
                    width="100"></el-table-column>
                  <el-table-column :show-overflow-tooltip="true" prop="warehousingNo" label="出厂编号"
                    width="100"></el-table-column>
                  <el-table-column :show-overflow-tooltip="true" prop="plateNumber" label="车船号"
                    width="100"></el-table-column>
                  <el-table-column :show-overflow-tooltip="true" prop="shipForecastNo" label="船运预报编号"
                    width="120"></el-table-column>
                  <el-table-column :show-overflow-tooltip="true" prop="specification" label="规格"
                    width="120"></el-table-column>
                  <el-table-column :show-overflow-tooltip="true" prop="model" label="材质" width="120"></el-table-column>
                  <el-table-column :show-overflow-tooltip="true" prop="number" label="件数" width="70"></el-table-column>
                  <el-table-column :show-overflow-tooltip="true" prop="allWeight" label="总重量（吨）"
                    width="120"></el-table-column>
                  <el-table-column :show-overflow-tooltip="true" prop="weight" label="理重（吨）"
                    width="120"></el-table-column>
                  <el-table-column :show-overflow-tooltip="true" prop="weighingWeight" label="过磅净重（吨）"
                    width="120"></el-table-column>
                  <el-table-column :show-overflow-tooltip="true" prop="weighingDate" label="过磅净重时间"
                    width="180"></el-table-column>
                  <el-table-column :show-overflow-tooltip="true" prop="factoryWeight" label="出厂过磅净重（吨）"
                    width="180"></el-table-column>
                  <el-table-column :show-overflow-tooltip="true" prop="warehouseName" label="仓位"
                    width="120"></el-table-column>
                  <el-table-column :show-overflow-tooltip="true" prop="instockNo" label="入库单号"
                    width="220"></el-table-column>
                  <el-table-column :show-overflow-tooltip="true" prop="driverName" label="司机"
                    width="150"></el-table-column>
                  <el-table-column :show-overflow-tooltip="true" prop="telephone" label="司机电话"
                    width="180"></el-table-column>
                  <el-table-column :show-overflow-tooltip="true" prop="idNumber" label="司机身份证号"
                    width="200"></el-table-column>
                  <el-table-column :show-overflow-tooltip="true" prop="sceneUser" label="现场人员"
                    width="120"></el-table-column>
                </el-table>
              </div>
              <div class="pags">
                <el-pagination background @current-change="handleCurrentChangeJC" :current-page="pageInfoJC.pageNo"
                  :page-size="pageInfoJC.pageSize" :page-sizes="[10, 20, 30, 40, 50]"
                  layout="total, sizes, prev, pager, next, jumper" @size-change="handleSizeChangeJC"
                  :total="totalJC"></el-pagination>
              </div>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="待进仓报表" name="fifth" :lazy="true">
          <djc-report v-if="DJCVisible && activeName == 'fifth'" :DJCVisible.sync="DJCVisible"></djc-report>
        </el-tab-pane>
        <el-tab-pane label="进仓记录" name="second" :lazy="true">
          <jc-record v-if="JCVisible && activeName == 'second'" :JCVisible.sync="JCVisible"></jc-record>
        </el-tab-pane>
        <el-tab-pane label="出库记录" name="third" :lazy="true">
          <ck-record v-if="CKVisible && activeName == 'third'" :CKVisible.sync="CKVisible"></ck-record>
        </el-tab-pane>
        <el-tab-pane label="转货记录" name="fourth" :lazy="true">
          <zh-record v-if="ZHVisible && activeName == 'fourth'" :ZHVisible.sync="ZHVisible"></zh-record>
        </el-tab-pane>
      </el-tabs>
    </div>
    <el-dialog title="请选择" :visible.sync="DialogVisible" :close-on-click-modal="false" width="40%" @close="BHQx" center>
      <div style="margin:20px auto 0">
        <div>
          <span style="display:inline-block;width:40%;text-align:right">出厂编号：</span>
          <el-radio-group v-model="BHradio">
            <el-radio :label="1">有出厂编号</el-radio>
            <el-radio :label="2">无出厂编号</el-radio>
          </el-radio-group>
        </div>
        <div style="margin-top:10px;">
          <span style="display:inline-block;width:40%;text-align:right">导出客户：</span>
          <el-radio-group v-model="HZradio">
            <el-radio :label="1">一级货主</el-radio>
            <el-radio :label="2">二级货主</el-radio>
          </el-radio-group>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="BHQx">取 消</el-button>
        <el-button type="primary" @click="BHOk">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  getVirtualBalingList,
  getDictionaryAll,
  getPutInStorageList,
  getPutInStorageNumber,
  getInStockCargoRecordList,
  getInWhAllStockInfoCargoListAllWeight,
  findUserTenantRelList,
  exTemplatePutInStorageList,
  exTemplatePutInCargoStorageList
} from '@/api/wms-stock'
import { zidian } from '@/api/wms-access'
import { getBtn } from '@/utils/getButton'
import DonMessage from '@/utils/message'
import { dateTimeFormat } from '@/utils/util'
import { exportExcel } from '@/utils/fileDown.js'
import JcRecord from './JCRecord.vue'
import CkRecord from './CKRecord.vue'
import ZhRecord from './ZHRecord.vue'
import DjcReport from './DjcReport.vue'
export default {
  components: { JcRecord, CkRecord, ZhRecord, DjcReport },
  data () {
    return {
      dateTimeFormat: dateTimeFormat, // 列表时间格式化
      activeName: 'first',
      radio: '1',
      // 卷板
      total: 0,
      pageInfoJB: {
        pageNo: 1,
        pageSize: 20
      },
      formDataJB: {
        productType: '',
        agreementNumber: '',
        customerName: '',
        inCustomerName: '',
        instockNo: '',
        instockPlateNumber: '',
        createTimeStart: '',
        createTimeEnd: '',
        contractNumber: '',
        specification: ''
      },
      // 字典
      addKuwei: [],
      addQ: [],
      addH: [],
      tableDataJB: [],
      totalJB: 0,
      allWeightJB: 0,
      allNumberJB: 0,
      CKName: [],
      gangJuanNum: '',
      // 建材
      formDataJC: {
        instockNo: '',
        instockPlateNumber: '',
        primaryCustomerName: '',
        customerName: '',
        instockDateStart: '',
        instockDateEnd: '',
        arrivalMethod: '',
        steelMillName: '',
        specification: '',
        model: '',
        plateNumber: ''
      },
      formData: {
        productType: '',
        steelMillName: '',
        specification: '',
        model: ''
      },
      pageInfoJC: {
        pageNo: 1,
        pageSize: 20
      },
      totalJC: 0,
      allWeightJC: 0,
      allNumberJC: 0,
      tableDataJC: [],
      productTypeData: [], // 货物类型
      steelMillNameData: [], // 产地
      specificationData: [], // 规格
      modelData: [], // 材质
      lengthData: [],
      specificationDisabled: true,
      steelMillNameDisabled: true,
      modelDisabled: true,
      goodsName: '',
      placeOfOrigin: '',
      specificationVal: '',
      modelVal: '',
      btnArr: [
        '00ZP00CB001',
        '00ZP00CB002',
        '00ZP00CB003',
        '00ZP00CB004',
        '00ZP00CB005',
        '00ZP00CB006',
        '00ZP00CB007',
        '00ZP00CB008',
        '00ZP00CB009',
        '00ZP00CB00A',
        '00ZP00CB00B',
        '00ZP00CB00C',
        '00ZP00CB00D',
        '00ZP00CB00E',
        '00ZP00CB00F',
        '00ZP00CB00G',
        '00ZP00CB00H',
        '00ZP00CB00I',
        '00ZP00CB00J',
        '00ZP00CB00K',
        '00ZP00CB00L',
        '00ZP00CB00M',
        '00ZP00CB00N',
        '00ZP00CB00O',
        '00ZP00CB00Q',
        '00ZP00CB00R',
        '00ZP00CB00S',
        '00ZP00CB00T',
        '00ZP00CB00U',
        '00ZP00CB00V',
        '00ZP00CB00W',
        '00ZP00CB00X',
        '00ZP00CB00Y',
        '00ZP00CB00Z',
        '00ZP00CB00a',
        '00ZM0S0100',
        '00ZM0S0200'

      ],
      btnFlg: [],
      h: 500,
      H: 500,
      xuanzhongArr: null,
      selectListId: [],
      selectList: [],
      JCVisible: false,
      CKVisible: false,
      ZHVisible: false,
      DJCVisible: false,
      arrivalMethodData: [
        {
          value: '1',
          label: '火运'
        },
        {
          value: '2',
          label: '汽运'
        },
        {
          value: '3',
          label: '船运'
        }
      ],
      // 凭证
      dialogVisibleImg: false,
      imgList: [],
      lookFlag: false,
      CKData: [],
      typeId: '', // 冷热卷
      kuweiId: '', // 库位id
      kuweiName: '', // 库位name
      QId: '', // 区位id
      QName: '', // 区位name
      HId: '', // 货位id
      HName: '', // 货位name
      typeName: '',
      typeData: [],
      DialogVisible: false,
      BHradio: 2,
      HZradio: 2,
      organizationName: ''
    }
  },
  methods: {
    // 仓库改变
    clickCK () {
      this.getVirtualBalingList()
    },
    // 货物类型卷板
    zidianS () {
      getDictionaryAll({
        groupNo: 'product_type'
      })
        .then(res => {
          this.typeData = res
        })
        .catch(err => {
          console.log(err)
        })
    },
    // 仓库名称
    findUserTenantRelList () {
      findUserTenantRelList({
        userCode: window.localStorage.getItem('userCode'),
        tenantCode: window.localStorage.getItem('tenantCode')
      })
        .then(res => {
          console.log(res)
          this.CKData = res
        })
        .catch(error => {
          DonMessage.error(error.message)
        })
    },
    handleClicktab (tab, event) {
      console.log(tab, event)
      this.JCVisible = false
      this.CKVisible = false
      this.ZHVisible = false
      this.DJCVisible = false
      if (tab.name == 'first') {
        this.chongzhiJB()
        this.chongzhiJC()
      } else if (tab.name == 'fifth') {
        this.DJCVisible = true
      } else if (tab.name == 'second') {
        this.JCVisible = true
      } else if (tab.name == 'third') {
        this.CKVisible = true
      } else if (tab.name == 'fourth') {
        this.ZHVisible = true
      }
    },
    handleClickradio () {
      if (this.radio == 1) {
        this.chongzhiJB()
      } else {
        this.chongzhiJC()
        let H = this.$refs.searchBoxJC.offsetHeight
        let pHJC = document.documentElement.clientHeight
        this.H = pHJC - H - 240 + 'px'
      }
    },
    // 卷板
    chaxunJB () {
      getInStockCargoRecordList({
        ...this.formDataJB,
        ...this.pageInfoJB,
        organizationIds: this.CKName.join(','),
        cargoBarcodes: this.gangJuanNum.replace(/\n/g, ',').split(',').filter(item => item != '').join(','),
        organizationFlag: 1
      })
        .then(res => {
          console.log(res)
          this.tableDataJB = res.pageInfo.list
          this.totalJB = res.pageInfo.total
          getInWhAllStockInfoCargoListAllWeight({
            ...this.formDataJB,
            ...this.pageInfoJB,
            organizationIds: this.CKName.join(','),
            cargoBarcodes: this.gangJuanNum.replace(/\n/g, ',').split(',').filter(item => item != '').join(','),
            organizationFlag: 1
          })
            .then(res => {
              console.log(res)
              this.allWeightJB = res.weight.allWeight
              this.allNumberJB = res.weight.allNumber
            })
            .catch(error => {
              DonMessage.error(error.message)
            })
        })
        .catch(error => {
          DonMessage.error(error.message)
        })
    },
    chongzhiJB () {
      this.pageInfoJB = {
        pageNo: 1,
        pageSize: 20
      }
      this.formDataJB = {
        productType: '',
        agreementNumber: '',
        customerName: '',
        inCustomerName: '',
        instockNo: '',
        instockPlateNumber: '',
        createTimeStart: '',
        createTimeEnd: '',
        contractNumber: '',
        specification: ''
      }
      this.CKName = []
      this.gangJuanNum = ''
      this.chaxunJB()
    },
    daochuJB () {
      exportExcel(
        this.global.wmsStockName + '/recordDetails/exportPutInCargoStorageList',
        {
          ...this.formDataJB,
          organizationIds: this.CKName.join(','),
          cargoBarcodes: this.gangJuanNum.replace(/\n/g, ',').split(',').filter(item => item != '').join(','),
          instockStatus: '1'
        },
        '入库记录信息表'
      )
    },
    MBdaochuJB () {
      // if (this.CKName.length != 1) {
      //   this.$message.error('请选择一个仓库')
      // } else if (this.formDataJB.inCustomerName == '') {
      //   this.$message.error('请填写入库客户')
      // } else {
      let arr = []
      this.CKData.map(item => {
        this.CKName.map(i => {
          if (i == item.relTenantCode) {
            arr.push(item.relTenantName)
          }
        })
      })
      exTemplatePutInCargoStorageList({
        ...this.formDataJB,
        organizationIds: this.CKName.join(','),
        cargoBarcodes: this.gangJuanNum.replace(/\n/g, ',').split(',').filter(item => item != '').join(','),
        instockStatus: '1',
        firstRequest: '1',
        organizationName: arr.join(',')
      })
        .then(res => {
          console.log(res)
          exportExcel(
            this.global.wmsStockName +
            '/recordDetails/exTemplatePutInCargoStorageList',
            {
              ...this.formDataJB,
              organizationIds: this.CKName.join(','),
              cargoBarcodes: this.gangJuanNum.replace(/\n/g, ',').split(',').filter(item => item != '').join(','),
              instockStatus: '1',
              organizationName: arr.join(',')
            },
            '入库记录信息表'
          )
        })
        .catch(error => {
          DonMessage.error(error.message)
        })
      // }
    },
    handleCurrentChangeJB (val) {
      this.pageInfoJB.pageNo = val
      this.chaxunJB()
    },
    handleSizeChangeJB (val) {
      this.pageInfoJB.pageSize = val
      this.chaxunJB()
    },
    // 建材
    chaxunJC () {
      this.getPutInStorageList()
    },
    chongzhiJC () {
      this.formDataJC = {
        instockNo: '',
        instockPlateNumber: '',
        primaryCustomerName: '',
        customerName: '',
        instockDateStart: '',
        instockDateEnd: '',
        arrivalMethod: '',
        steelMillName: '',
        specification: '',
        model: '',
        plateNumber: ''
      }
      this.formData = {
        productType: '',
        steelMillName: '',
        specification: '',
        model: ''
      }
      this.pageInfoJC = {
        pageNo: 1,
        pageSize: 20
      }
      this.CKName = []
      this.chaxunJC()
      this.getVirtualBalingList()
    },
    daochuJC () {
      exportExcel(
        this.global.wmsStockName + '/recordDetails/exportPutInStorageList',
        {
          ...this.formDataJC,
          ...this.formData,
          organizationIds: this.CKName.join(','),
          instockStatus: '1'
        },
        '入库记录信息表'
      )
    },
    MBdaochuJC () {
      console.log(this.CKName)
      if (!this.formDataJC.primaryCustomerName && !this.formDataJC.customerName) {
        DonMessage.error('请输入一级货主或二级货主')
        return
      }
      this.DialogVisible = true
    },
    BHOk () {
      let BHchange
      if (this.BHradio == 2) {
        BHchange = ''
      } else {
        BHchange = 1
      }
      let arr = []
      this.CKData.map(item => {
        this.CKName.map(i => {
          if (i == item.relTenantCode) {
            arr.push(item.relTenantName)
          }
        })
      })
      exTemplatePutInStorageList({
        ...this.formDataJC,
        ...this.formData,
        organizationIds: this.CKName.join(','),
        instockStatus: '1',
        templateChange: BHchange,
        firstRequest: '1',
        exportCustomer: this.HZradio,
        organizationName: arr.join(',')
      })
        .then(res => {
          exportExcel(
            this.global.wmsStockName +
            '/recordDetails/exTemplatePutInStorageList',
            {
              ...this.formDataJC,
              ...this.formData,
              organizationIds: this.CKName.join(','),
              instockStatus: '1',
              templateChange: BHchange,
              exportCustomer: this.HZradio,
              organizationName: arr.join(',')
            },
            '入库记录信息表'
          )
          this.DialogVisible = false
          this.HZradio = 2
          this.BHradio = 2
        })
        .catch(error => {
          DonMessage.error(error.message)
        })
    },
    BHQx () {
      this.DialogVisible = false
      this.HZradio = 2
      this.BHradio = 2
    },
    handleRowClick (row) {
      this.xuanzhongArr = row
    },
    // 列表查询
    getPutInStorageList () {
      getPutInStorageList({
        ...this.formDataJC,
        ...this.formData,
        ...this.pageInfoJC,
        organizationIds: this.CKName.join(',')
      })
        .then(res => {
          console.log(res)
          this.tableDataJC = res.list
          this.totalJC = res.total
          this.tableDataJC.forEach(item => {
            item.allWeight = parseFloat(item.allWeight.toFixed(6))
            item.weight = parseFloat(item.weight.toFixed(6))
          })
          this.getPutInStorageNumber()
        })
        .catch(error => {
          DonMessage.error(error.message)
        })
    },
    // 总吨数总件数
    getPutInStorageNumber () {
      getPutInStorageNumber({
        ...this.formDataJC,
        ...this.formData,
        organizationIds: this.CKName.join(',')
      })
        .then(res => {
          console.log(res)
          // this.allWeightJC = res.totalAllWeight
          this.allWeightJC = parseFloat(res.totalAllWeight.toFixed(6))

          this.allNumberJC = res.totalNumber
        })
        .catch(error => {
          DonMessage.error(error.message)
        })
    },
    // 下拉框
    getVirtualBalingList () {
      getVirtualBalingList({
        organizationFlag: 1
      })
        .then(res => {
          console.log(res)
          this.steelMillNameData = []
          this.specificationData = []
          this.modelData = []
          this.productTypeData = []
          var obj = {}
          for (var i = 0; i < res.length; i++) {
            if (!obj[res[i].productTypeName]) {
              this.productTypeData.push(res[i])
              obj[res[i].productTypeName] = true
            }
          }
          // this.productTypeData = Array.from(new Set(res.map(item => item.productTypeName)))
          this.steelMillNameData = Array.from(
            new Set(res.map(item => item.placeOfOrigin))
          )
          this.specificationData = Array.from(
            new Set(res.map(item => item.specification))
          )
          this.modelData = Array.from(new Set(res.map(item => item.model)))
        })
        .catch(error => {
          DonMessage.error(error.message)
        })
    },
    // // 货物类型下拉框改变事件
    // productTypeChange (val) {
    //   // this.goodsName = val
    //   getVirtualBalingList({
    //     productType: this.formData.productType,
    //     placeOfOrigin: this.formData.steelMillName,
    //     specification: this.formData.specification,
    //     model: this.formData.model
    //   }).then(res => {
    //     this.steelMillNameData = []
    //     this.specificationData = []
    //     this.modelData = []
    //     this.productTypeData = []

    //     var obj = {}
    //     for (var i = 0; i < res.length; i++) {
    //       if (!obj[res[i].productTypeName]) {
    //         this.productTypeData.push(res[i])
    //         obj[res[i].productTypeName] = true
    //       }
    //     }
    //     this.steelMillNameData = Array.from(new Set(res.map(item => item.placeOfOrigin)))
    //     this.specificationData = Array.from(new Set(res.map(item => item.specification)))
    //     this.modelData = Array.from(new Set(res.map(item => item.model)))
    //   }).catch(err => {
    //     this.$message.error(err.message)
    //   })
    // },
    // // 产地下拉框改变事件
    // steelMillNameChange (val) {
    //   // this.placeOfOrigin = val
    //   getVirtualBalingList({
    //     productType: this.formData.productType,
    //     placeOfOrigin: this.formData.steelMillName,
    //     specification: this.formData.specification,
    //     model: this.formData.model
    //   }).then(res => {
    //     this.steelMillNameData = []
    //     this.specificationData = []
    //     this.modelData = []
    //     this.productTypeData = []

    //     var obj = {}
    //     for (var i = 0; i < res.length; i++) {
    //       if (!obj[res[i].productTypeName]) {
    //         this.productTypeData.push(res[i])
    //         obj[res[i].productTypeName] = true
    //       }
    //     }
    //     this.steelMillNameData = Array.from(new Set(res.map(item => item.placeOfOrigin)))
    //     this.specificationData = Array.from(new Set(res.map(item => item.specification)))
    //     this.modelData = Array.from(new Set(res.map(item => item.model)))
    //   }).catch(err => {
    //     this.$message.error(err.message)
    //   })
    // },
    // // 规格下拉框改变事件
    // specificationChange (val) {
    //   // this.specificationVal = val
    //   getVirtualBalingList({
    //     productType: this.formData.productType,
    //     placeOfOrigin: this.formData.steelMillName,
    //     specification: this.formData.specification,
    //     model: this.formData.model
    //   }).then(res => {
    //     this.steelMillNameData = []
    //     this.specificationData = []
    //     this.modelData = []
    //     this.productTypeData = []
    //     var obj = {}
    //     for (var i = 0; i < res.length; i++) {
    //       if (!obj[res[i].productTypeName]) {
    //         this.productTypeData.push(res[i])
    //         obj[res[i].productTypeName] = true
    //       }
    //     }
    //     this.steelMillNameData = Array.from(new Set(res.map(item => item.placeOfOrigin)))
    //     this.specificationData = Array.from(new Set(res.map(item => item.specification)))
    //     this.modelData = Array.from(new Set(res.map(item => item.model)))
    //   }).catch(err => {
    //     this.$message.error(err.message)
    //   })
    // },
    // // 材质下拉框改变事件
    // modelChange (val) {
    //   // this.modelVal = val
    //   getVirtualBalingList({
    //     productType: this.formData.productType,
    //     placeOfOrigin: this.formData.steelMillName,
    //     specification: this.formData.specification,
    //     model: this.formData.model
    //   }).then(res => {
    //     this.lengthData = []
    //     this.steelMillNameData = []
    //     this.specificationData = []
    //     this.modelData = []
    //     this.productTypeData = []
    //     var obj = {}
    //     for (var i = 0; i < res.length; i++) {
    //       if (!obj[res[i].productTypeName]) {
    //         this.productTypeData.push(res[i])
    //         obj[res[i].productTypeName] = true
    //       }
    //     }
    //     this.steelMillNameData = Array.from(new Set(res.map(item => item.placeOfOrigin)))
    //     this.specificationData = Array.from(new Set(res.map(item => item.specification)))
    //     this.modelData = Array.from(new Set(res.map(item => item.model)))
    //   }).catch(err => {
    //     this.$message.error(err.message)
    //   })
    // },
    handleCurrentChangeJC (val) {
      this.pageInfoJC.pageNo = val
      this.chaxunJC()
    },
    handleSizeChangeJC (val) {
      this.pageInfoJC.pageSize = val
      this.chaxunJC()
    }
  },
  updated () {
    var _this = this
    if (_this.activeName == 'first') {
      document.onkeydown = function (e) {
        let key = window.event.keyCode
        if (key == 13) {
          // console.log('123')
          _this.chaxun()
        }
      }
    }
  },
  created () {
    this.btnFlg = getBtn(this.btnArr, '/ChuRuReport')
    this.chaxunJC()
    this.chaxunJB()
    this.getVirtualBalingList()
    this.findUserTenantRelList()
    this.zidianS()
  },
  mounted () {
    let h = this.$refs.searchBoxJB.offsetHeight
    let pH = document.documentElement.clientHeight
    this.h = pH - h - 240 + 'px'
  }
}
</script>

<style lang="less" scoped>
.inpBox1 {
  .el-form-item {
    margin-left: 10px;
    margin-bottom: 0px;
  }
}
/deep/.el-tabs__header{
  margin-bottom: 0;
}
</style>
